export default __webpack_public_path__ + "static/media/Sume_Premio_EdificiosIndustriales.79564c7c.png";